import React, { useEffect, useState } from 'react'
import MainLayouts from '../../layouts/MainLayouts'
import _Api from '../../services/Api/_Api'
import { _Button, _Checkbox, _Input, _Select, _Date } from '../../services/Forms/Forms'

import { Table, Form, Popover, Button, Tag, Popconfirm, Radio, DatePicker, Checkbox } from 'antd';
import { RandomText } from '../../services/Text/RandomText';
import { CopyOutlined, DeleteColumnOutlined, DownSquareOutlined, DropboxOutlined, EditOutlined, FieldTimeOutlined, FileSearchOutlined, MinusSquareOutlined, PlusSquareOutlined, RightSquareOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { _Col, _Row } from '../../services/Forms/LayoutBootstrap';
// import ExpandShowDataPengadaan from './Expand_ShowDataPengadaan';
import moment from 'moment';
import { useHistory } from 'react-router';
// import EditPekerjaan from './EditPekerjaan';
import { SocketIO, TglSekarang, fDB, formatNumber, formatTglWaktu, globalText } from '../../services/Text/GlobalText';
import { Col, Row } from 'react-bootstrap';
import { _Toastr } from '../../services/Toastr/Notify/_Toastr';
import { acakText, ubahText } from '../../services/Crypto';
import dayjs from 'dayjs';
import { baseURL_R_file } from '../../services/BaseUrl';
import CountDownX from '../../services/Forms/CountDown';
import RiwayatKonselingExpand from './RiwayatKonselingExpand.jsx';


function RiwayatKonselingGizi() {

    const [steps, setsteps] = useState(0)
    const [jenisPekerjaan, setjenisPekerjaan] = useState([])
    const [riwayatKonseling, setriwayatKonseling] = useState([])
    const [ppk, setppk] = useState([])
    const [loading, setloading] = useState(false)
    const [jenispk, setjenispk] = useState("")
    const [formLoad] = Form.useForm()
    const [edit, setedit] = useState(false)
    const [recordData, setrecordData] = useState([])
    const [jenisArsip, setjenisArsip] = useState([])

    const CACHE_KEY = "riwayat_gizi_filter";

    const getCachedFilter = () => {
        try {
            const cache = localStorage.getItem(CACHE_KEY);
            return cache ? JSON.parse(cache) : null;
        } catch (e) {
            return null;
        }
    };

    const setCachedFilter = (val) => {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(val));
        } catch (e) { }
    };

    const clearCachedFilter = () => {
        localStorage.removeItem(CACHE_KEY);
    };



    var histori = useHistory()

    // const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />);


    // const mulaiKonseling = (rc) => {
    //     histori.push({
    //         pathname: '/ProsesKonseling',
    //         search: '?konsId=' + rc.id + "&xtemp=" + acakText("123")
    //     }) 
    //     // window.location.href = "/ProsesKonseling?konsId=" + rc.id + "&xtemp=" + acakText("123")
    // }

    const mulaiKonseling = (rc) => {
        console.log(rc)
        var nama = rc.namapembeli

        nama = nama
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");

        const room = `${rc.kodeorderkonseling}-${nama}`

        histori.push({
            pathname: '/VideoCallKonseling',
            search: '?konsId=' + rc.id + "&dvId=" + rc.deviceid + "&xtemp=" + acakText("123") + "&fcm=" + rc.fcm_token + "&room=" + room
        })

        // window.location.href = "/ProsesKonseling?konsId=" + rc.id + "&xtemp=" + acakText("123")

    }
    const editData = (rc) => {
        histori.push({
            pathname: '/OrderKonseling',
            search: '?konsId=' + rc.id + "&xtemp=" + acakText("123")
        })
    }
    const hapusBerkas = (rc) => {
        console.log('rc', rc)
        _Api.delete("deleteProyek?id=" + rc.id).then(res => {
            console.log('res', res)
            if (res.data.sts == 1) {
                _Toastr.success('Berhasil')
                loadData()
            }
        })
    }


    const columns = [
        {
            title: '',
            width: "100px",
            align: 'center',
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    <Button type="ghost" shape="shape" icon={<FieldTimeOutlined />} onClick={() => editData(record)} > Detail </Button>

                </div>

        },
        {
            title: 'No',
            width: "70px",
            // sorter: true,
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    {j + 1}
                </div>
        },
        {
            title: 'Tanggal Rencana Konseling',
            width: "140px",
            // sorter: true,
            render: (record, i, j) =>
                <div style={{ textAlign: "center" }}>
                    {record.tgl && moment(record.tgl).format('DD-MM-YYYY H:m')} Wita
                </div>
        },
        {
            title: 'Nama Pelanggan',
            width: "200px",
            // sorter: true,
            render: (record, i, j) =>
                <div >
                    {record.namapembeli}
                </div>
        },
        {
            title: 'Jumlah Tagihan',
            width: "130px",
            // sorter: true,
            render: (record, i, j) =>
                <center> <b>
                    Rp. {formatNumber(record.tagihan)}
                    {
                        record.status == "KPK" && <div className='text-success'>Lunas</div>
                    }
                </b>
                </center>
        },
        // {
        //     title: 'Metode Pembayaran / Batas Pembayaran',
        //     // sorter: true,
        //     width: "150px",
        //     render: (_, rc) =>
        //         <center>
        //             {
        //                 rc.bank == "MANUAL" && "Manual"
        //             }
        //             <b style={{ textTransform: "capitalize" }}>  {rc.metodebayar} </b>
        //             {
        //                 rc.status == "MP" &&
        //                 <div>
        //                     <CountDownX tgl={rc.batasbayar} />
        //                     <div style={{ paddingTop: "-30px !important" }}> {rc.batasbayar && moment(rc.batasbayar).format('DD-MM-YYYY H:m')} Wita</div>
        //                 </div>
        //             }
        //             {/* <Tag size="large" color={rc.metodebayar == "transfer" ? "green" : rc.metodebayar == "eCatalog" ? "orange" : "blue"}>  <b style={{ textTransform: "capitalize" }}>  {rc.metodebayar} </b> </Tag> */}
        //         </center>
        // },
        // {
        //     title: 'Bank Tujuan Transfer',
        // sorter: true,
        //     width: "140px",
        //     render: (_, rc) =>
        //         <div> <b>     </b>
        //             {
        //                 rc.bank == "MANUAL" ? "Manual" :
        //                     <img height={40} src={baseURL_R_file + "images/bank/" + rc.bank + ".png"} alt={rc.bank} />
        //             }
        //         </div>
        // },
        {
            title: 'Status',
            // sorter: true,
            width: "150px",
            render: (_, rc) =>
                <>
                    <div style={{ lineHeight: "100%" }} className={'p-2 text-center rounded b bg-' + rc.class} > {rc.jenistransaksi} </div>
                    {
                        rc.status == "KPK" && // KPK = Konfirmasi Pembayaran Konseling
                        <_Button className="blink_me mt-1" onClick={() => mulaiKonseling(rc)} label="Mulai Konseling" block size="large" />
                    }
                </>
        },
        {
            title: 'Catatan Petugas Gizi',
            // sorter: true,
            width: "200px",
            render: (_, rc) =>
                <div>
                    <b> {rc.jenispekerjaan} <br /> <Tag color="yellow" style={{ textTransform: "uppercase" }}> {rc.bidang} </Tag> </b>
                </div>
        },


    ];

    const stile = {
        icon: { fontSize: "25px", color: "#378994" }
    }

    const loadData = (val) => {

        // simpan filter ke cache
        if (val) {
            setCachedFilter(val);
        }

        setriwayatKonseling([])
        setedit(false)

        let param = null

        if (val) {
            param = {
                ...val,
                tglawal: val.tglawal ? moment(val.tglawal).format('YYYY-MM-DD 00:00:00') : "",
                tglakhir: val.tglakhir ? moment(val.tglakhir).format('YYYY-MM-DD 23:59:59') : ""
            }
        }

        setloading(true)

        _Api.get("/get-riwayat-konseling-gizi", { params: param }).then(res => {
            setriwayatKonseling(res.data)
            setloading(false)
        })
    }


    useEffect(() => {
        var role = ubahText(sessionStorage.getItem('x-auth-user'))
        console.log('role', role)

        const cached = getCachedFilter();

        if (cached) {

            formLoad.setFieldsValue({
                ...cached,
                tglawal: cached.tglawal ? moment(cached.tglawal) : moment(),
                tglakhir: cached.tglakhir ? moment(cached.tglakhir) : moment()
            });

            loadData(cached);

        } else {

            formLoad.submit();

        }

    }, [])

    useEffect(() => {
        SocketIO.on("requestKonfirmasipembayaran", (data) => {
            formLoad.submit()
        });
    }, [])

    const listStatus = [
        {
            label: 'Draft',
            value: 'Draft',
        },
        {
            label: 'Menunggu Pembayaran',
            value: 'mp',
        },
        {
            label: 'Pembayaran Selesai',
            value: 'ps',
        },
    ];
    return (
        <MainLayouts>
            <br />
            <h3 className='text-center'> RIWAYAT KONSELING </h3>
            <Form
                layout='vertical'
                onFinish={loadData}
                initialValues={{
                    ...(getCachedFilter() || {}),
                    tglawal: getCachedFilter()?.tglawal
                        ? moment(getCachedFilter().tglawal)
                        : moment(),
                    tglakhir: getCachedFilter()?.tglakhir
                        ? moment(getCachedFilter().tglakhir)
                        : moment()
                }}
                form={formLoad}
            >
                {/* <_Input label="Nama Pekerjaan" onChange={e => console.log(e.target.value)} /> */}
                <Row>
                    <_Date label="Tanggal" sm={2} name="tglawal" format="DD-MM-YYYY 00:00" />
                    <_Date label="Sampai" sm={2} name="tglakhir" format="DD-MM-YYYY 23:59" />
                    <_Input label="Nama Pasien" sm={2} name="namapasien" />
                    <_Input label="Alamat" sm={2} name="alamat" />
                    {/* <_Select size="large" option={jenisPekerjaan}
                        val="id" name="status" sm={2}
                        caption="jenispekerjaan" label="Status" /> */}
                    <Col sm={4}>
                        <Form.Item name="status" label="Status">
                            <Checkbox.Group
                                options={listStatus}
                                defaultValue={['Apple']}
                            />
                        </Form.Item>
                    </Col>
                    <Col></Col>
                    <_Button label="Refresh" className='mt-1' icon={<FileSearchOutlined />} sm={2} block submit />
                    <_Button label="Konseling Baru" className='mt-1' icon={<DropboxOutlined />} onClick={() => histori.push("/OrderKonselingManual")} color="green" sm={2} block />
                </Row>
            </Form>

            {/* {edit && <EditPekerjaan show={edit} close={() => setedit(false)} loadData={loadData} recordData={recordData} />} */}

            <Table
                size="large"
                rowKey="id"
                className='mt-2'
                // loading={loading}
                expandable={{
                    expandedRowRender: (record) => RiwayatKonselingExpand(record),
                    expandIcon: ({ expanded, onExpand, record }) =>
                        expanded ? (
                            <MinusSquareOutlined
                                style={stile.icon}
                                onClick={(e) => onExpand(record, e)}
                            />
                        ) : (
                            <PlusSquareOutlined
                                style={stile.icon}
                                onClick={(e) => onExpand(record, e)}
                            />
                        ),
                }}
                onRow={(record, rowIndex) => {
                    return {
                        onDoubleClick: (event) => {
                            console.log(record);
                        },
                    };
                }}
                scroll={{ y: 500 }}
                pagination={{ pageSize: 30 }}
                columns={columns}
                dataSource={riwayatKonseling}
            />
            <br />

        </MainLayouts>
    )
}

export default RiwayatKonselingGizi
